module.exports = __webpack_public_path__ + "img/eat_out_22.7a4bf867.jpg";